export default {
	"火蚁联盟": "FireAnt Alliance",
	"节点订阅系统": "節點訂閱系統",
	"首页": "首頁",
	"娱乐经济的能量核心": "娛樂經濟的能量核心",
	"推荐人：": "推薦人：",
	"我的邀请链接（点击复制）": "我的邀請連結（點擊複製）",
	"初级节点": "初級節點",
	"高级节点": "高級節點",
	"獲得全網NFT新增業績2.5%分紅": "獲得全網NFT新增業績2.5%分紅",
	"获得4倍代币燃料值": "獲得4倍代幣燃料值",
	"获得5倍代币燃料值": "獲得5倍代幣燃料值",
	"获得娱乐游戏平台收益的5%分红": "獲得娛樂平台收益的5%分紅",
	"获得每日产出FAC代币2%分配": "獲得每日產出FAC代幣2%分配",
	"请连接钱包": "請連接錢包",
	"USDT余额不足": "USDT餘額不足",
	"转账已发起": "轉帳已發起",
	"转账被取消": "轉帳被取消",
	"取消": "取消",
	"未连接钱包": "未連接錢包",
	"复制成功": "複製成功",
	"订单记录": "訂單記錄",
	"我的社群": "我的社群",
	"节点预售": "節點預售",
	"我的订单": "我的訂單",
	"创建时间：": "建立時間：",
	"转账哈希：": "轉帳雜湊：",
	"购买初级节点": "購買初級節點",
	"购买高级节点": "購買高級節點",
	"空": "空",
	"獲得算力挖礦": "獲得算力挖礦",
	"已购买": "已購買",
	"獲得DAO投票權限": "獲得DAO投票權限",
	"付款地址：": "付款地址：",
	"節點類型：": "節點類型：",
	"获取中": "獲取中",
	"交易中": "交易中",
	"金额：": "金額：",
	"推荐地址：": "推薦地址：",
	"推荐时间：": "推薦時間：",
	"社群总业绩 U：": "社群總業績 U：",
	"社群总地址 个：": "社群總地址 個：",
	"确认绑定?": "確認綁定?",
	"确定": "確定",
	"操作成功": "操作成功",
	"操作失败": "操作失敗",
	"获取数据失败": "獲取數據失敗",
	"授权成功": "授權成功",
	"授权失败": "授權失敗",
	"操作中": "操作中",
	"进入共振": "進入共振",
	"赎回": "贖回",
	"领取奖励": "領取獎勵",
	"开始共振": "開始共振",
	"共振中，距离共振结束还有": "共振中，距離共振結束還有",
	"NFT已经失效": "NFT已經失效",
	"超时，NFT即将失效": "超時，NFT即將失效",
	"共振未开始": "共振未開始",
	"赎回共振金": "贖回共振金",
	"共振结束": "共振結束",
	"详情": "詳情",
	"次数：": "次數：",
	"算力：": "算力：",
	"燃料：": "燃料：",
	"剩余用能量：": "剩餘用能量：",
	"总能量：": "總能量：",
	"类型：": "類型：",
	"参与共振流动性": "參與共振流動性",
	"加载中": "加載中",
	"未开始": "未開始",
	"共振中": "共振中",
	"异常": "異常",
	"USD资产": "USD資產",
	"FAC资产": "FAC資產",
	"NFT卡牌：": "NFT卡牌：",
	"共振金：": "共振金：",
	"总收益：": "總收益：",
	"共振奖励：": "共振獎勵：",
	"直推奖励：": "直推獎勵：",
	"层级奖励：": "層級獎勵：",
	"社区奖励：": "社區獎勵：",
	"节点分红：": "節點分紅：",
	"已领取：": "已領取：",
	"我的算力：": "我的算力：",
	"我的燃料：": "我的燃料：",
	"我的矿池：": "我的礦池：",
	"已释放FAC：": "已釋放FAC：",
	"社区奖励FAC：": "社區獎勵FAC：",
	"节点分红FAC：": "節點分紅FAC：",
	"平台分红FAC：": "平台分紅FAC：",
	"可领取FAC：": "可領取FAC：",
	"已领取FAC：": "已領取FAC：",
	"领取": "領取",
	"没有可提取的FAC": "沒有可提取的FAC",
	"没有可用的能量": "沒有可用的能量",
	"参数获取失败": "參數獲取失敗",
	"领取成功": "領取成功",
	"共振奖励提取成功": "共振獎勵提取成功",
	"共振奖励提取失败": "共振獎勵提取失敗",
	"层级奖励提取成功": "層級獎勵提取成功",
	"NFT价格": "NFT價格",
	"数量": "數量",
	"总价": "總價",
	"账户余额": "賬戶餘額",
	"购买NFT": "購買NFT",
	"推荐地址": "推薦地址",
	"我的邀请链接": "我的邀請連結",
	"复制邀请链接": "複製邀請連結",
	"购买失败": "購買失敗",
	"购买成功": "購買成功",
	"我的资产": "我的資產",
	"节点认购": "節點認購",
	"时": "時",
	"分": "分",
	"秒": "秒",
	"可领取：": "可領取：",
	"我的能量：": "我的能量：",
	"提取": "提取",
	"推荐钱包：": "推薦錢包：",
	"确认绑定？": "確認綁定？",
	"火蚁联盟将于{time}后启动。": "火蟻聯盟將於{time}後啟動。",
	"本操作将在24小时公测期后开放": "本操作將在24小時公測期後開放",
	"暂未开放": "暫未開放",
	"请使用分享链接打开。": "請使用分享連結打開。",
	"Fire Ant Alliance邀请您参与我们的多签。": "Fire Ant Alliance 邀請您參與我們的多重簽名。",
	"操作过于频繁": "操作過於頻繁",
	"社区奖励提取成功": "社區獎勵提取成功",
	"已释放节点分红FAC：": "已釋放節點分紅FAC：",
	"社群节点总地址 个：": "社群節點總地址 個：",
	"社群NFT总地址 个：": "社群NFT總地址 個：",
	"NFT业绩 U：": "NFT業績 U：",
	"节点分红释放FAC：": "節點分紅釋放FAC：",
	"矿池释放FAC：": "礦池釋放FAC：",
	"没有可领取的共振奖励": "沒有可領取的共振獎勵",
	"没有可领取的直推奖励": "沒有可領取的直推獎勵",
	"无剩余能量": "無剩餘能量",
}